import { render, staticRenderFns } from "./GalvanometerViz.vue?vue&type=template&id=526785a0&scoped=true"
import script from "./GalvanometerViz.vue?vue&type=script&lang=js"
export * from "./GalvanometerViz.vue?vue&type=script&lang=js"
import style0 from "./GalvanometerViz.vue?vue&type=style&index=0&id=526785a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526785a0",
  null
  
)

export default component.exports